export default "__VITE_ASSET__CMuFClEY__"